import './style.less';
import modalTemplate from 'modals/eventEvaluation/template.html';
import modalController from 'modals/eventEvaluation/controller';
import { flatten, isEqual, keyBy, clone } from 'lodash';

export default function ($scope, $state, $log, $uibModal, $stateParams, ApiClass, Swal) {
  'ngInject';

  const vm = this;
  vm.$onChanges = activate;
  $scope.routeParmas = $stateParams;
  $scope.resultsQueried = false;
  const id = $stateParams.eventid;

  $scope.selected = 0;
  $scope.selectAll = false;
  $scope.submitBtn = false;

  $scope.updateSelectAll = selectAll => {
    $scope.filtered.forEach(user => (user.selected = selectAll));
    $scope.updateSelected();
  };

  $scope.onFilter = function (stCtrl) {
    const oldFiltered = ($scope.filtered || []).map(({ email }) => email);
    const newFiltered = stCtrl.getFilteredCollection().map(({ email }) => email);
    if (!isEqual(oldFiltered, newFiltered)) $scope.selectAll = false;
    $scope.filtered = stCtrl.getFilteredCollection();
  };

  $scope.updateSelected = () => {
    const selectedUsers = $scope.eventRegistrants.filter(user => user.selected);
    $scope.selected = selectedUsers.length;
    return selectedUsers;
  };

  $scope.filter = type => {
    switch (type) {
      case 'complete':
        $scope.eventRegistrants = clone($scope.locationRegistrants).filter(
          ({ profile_uid }) => $scope.reviewsObj[profile_uid]
        );
        break;
      case 'incomplete':
        $scope.eventRegistrants = clone($scope.locationRegistrants).filter(
          ({ profile_uid }) => !$scope.reviewsObj[profile_uid]
        );
        break;
      default:
        $scope.eventRegistrants = clone($scope.locationRegistrants);
        break;
    }
  };

  $scope.sendEvals = () => {
    $scope.submitBtn = true;
    const users = $scope.updateSelected();
    const profile_uids = users.map(({ profile_uid }) => profile_uid);
    checkDate()
      .then(() => ApiClass.eventsIdTypePatch(
        { id: vm.event.event_id, type: 'attendees' },
        { profile_uids, sendEval: true },
        { queryParams: { manage: true } }
      ))
      .then(() => {
        $scope.submitBtn = false;
        $state.reload();
        Swal.toast('Evaluations sent!');
      })
      .catch(error => {
        $scope.submitBtn = false;
        $log.error(error);
        throw error;
      });
  };

  function checkDate() {
    if (new Date($scope.event.delivery_end_date).getTime() > new Date().getTime()) {
      return Swal.confirm(
        'Send Evaluations',
        'This event has not ended. Do you still want to send evaluations?',
        'info'
      );
    }
    return Promise.resolve();
  }

  $scope.openEval = profile_uid => {
    $uibModal
      .open({ template: modalTemplate, controller: modalController(id, profile_uid), size: 'lg', backdrop: true })
      .result.catch(error => {
        if (error === 'cancel' || error === 'backdrop click') return;
        $log.error(error);
      });
  };

  function activate() {
    if (vm.event) {
      const event = vm.event;
      $scope.event = event;
      $scope.reviewsObj = keyBy(event.reviews, 'profile_uid');
      $scope.eventRegistrants = flatten(event.locations.map(({ attendees }) => attendees));
      $scope.locationRegistrants = clone($scope.eventRegistrants);
      $scope.resultsQueried = true;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/admin/eventManager/event/evaluations/controller.js